<div class="ibox detailed-view-ibox"
     *ngIf="settingsIntegrationsService.showDetailedView && settingsIntegrationsService.selectedItemData">
    <div class="detailed-view-header">
        <div class="col-md-3 detailed-view-image" style="padding: 0;">
            <div class="placeholder"></div>
        </div>
        <div class="col-md-9" style="padding-right: 25px;">
            <div class="category-name">Category</div>
            <h3>Name of the  App Goes here</h3>
            <div class="display-flex m-b-md">
                <div class="app-price">Free</div>
                <div class="app-rating">
                    <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                    <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                    <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                    <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                    <i class="fa fa-star-o" aria-hidden="true"></i>
                </div>
            </div>
            <button class="btn btn-outer-primary mtv-primary-color mtv-primary-border m-b-xl" type="button">
                Uninstall
            </button>
        </div>
        <span class="close-detailed-view" (click)="settingsIntegrationsService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info">
            <form #form="ngForm"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">
                <div>
                    <div class="detailed-view-navigation" *ngIf="settingsIntegrationsService.showListView">
                        <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                            <div class="button-section" (click)="changeNavPosition('about')"
                                 [ngStyle]="{'background-color': navPosition == 'about' ? '#ebebeb' : ''}">
                                About the App
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                            <div class="button-section" (click)="changeNavPosition('settings')"
                                 [ngStyle]="{'background-color': navPosition == 'settings' ? '#ebebeb' : ''}">
                                Settings
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="navPosition == 'about'">
                    Reference site about Lorem Ipsum
                </div>
                <div class="general-tab" *ngIf="navPosition == 'settings'">
                    <div class="settings-amenities-slider-container">
                        <span>Allow Residents To Allow</span>
                        <mat-slide-toggle name="allowResidentsToBook"
                                          (change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook ? 1: 0})"
                                          [(ngModel)]="settingsIntegrationsService.selectedItemData.allowResidentsToBook">
                        </mat-slide-toggle>
                    </div>
                    <hr>
                    <div class="settings-amenities-slider-container">
                        <span>Allow Residents To Allow</span>
                        <mat-slide-toggle name="allowResidentsToBook"
                                          (change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook ? 1: 0})"
                                          [(ngModel)]="settingsIntegrationsService.selectedItemData.allowResidentsToBook">
                        </mat-slide-toggle>
                    </div>
                    <hr>
                    <div class="settings-amenities-slider-container">
                        <span>Allow Residents To Allow</span>
                        <mat-slide-toggle name="allowResidentsToBook"
                                          (change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook ? 1: 0})"
                                          [(ngModel)]="settingsIntegrationsService.selectedItemData.allowResidentsToBook">
                        </mat-slide-toggle>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-integrations/settings-integrations-detailed-view/settings-integrations-detailed-view.component.html